import api from '../../../core/api/client';

const BASE = '/social-accounts';
const path = (id) => `${BASE}/${encodeURIComponent(id)}`;

const toApiError = (error) => {
  if (error?.response) {
    const d = error.response.data;
    return {
      status: error.response.status,
      message: d?.detail || d?.message || d?.error || error.message || 'Request failed',
      data: d,
    };
  }
  return { status: 0, message: error?.message || 'Unexpected error', data: null };
};

const wrap = async (fn) => {
  try {
    return await fn();
  } catch (error) {
    throw toApiError(error);
  }
};

export const socialAccountsService = {
  async list(onlyActive = false) {
    return wrap(async () => {
      const response = await api.get(BASE, { params: onlyActive ? { only_active: true } : {} });
      return response.data;
    });
  },

  async create(data) {
    return wrap(async () => {
      const response = await api.post(BASE, data);
      return response.data;
    });
  },

  async get(accountId) {
    return wrap(async () => {
      const response = await api.get(path(accountId));
      return response.data;
    });
  },

  async update(accountId, updates) {
    return wrap(async () => {
      const response = await api.patch(path(accountId), updates);
      return response.data;
    });
  },

  async delete(accountId) {
    return wrap(async () => {
      const response = await api.delete(path(accountId));
      return response.data;
    });
  },

  async recordSnapshot(accountId, snapshot) {
    return wrap(async () => {
      const response = await api.post(`${path(accountId)}/snapshot`, snapshot);
      return response.data;
    });
  },
};
